module.exports = __webpack_public_path__ + "img/model3.ccf60689.png";